import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TreinoUsuarioService {
  private url = 'api/treinoUsuario';
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.url = baseUrl + this.url;
  }

  getByUser(): Observable<any> {
    const apiurl = `${this.url}/getTreinosByUser`;
    return this.http.get<any>(apiurl);
  }

  getAllExerciciosByUser(): Observable<any> {
    const apiurl = `${this.url}/getAllExerciciosByUser`;
    return this.http.get<any>(apiurl);
  }

  getExerciciosByTreinoId(treinoId: number) {
    return this.http.get<any[]>(`/api/treino-usuario/${treinoId}/exercicios`);
  }

  getAllByUserAndDiaSemana(diaSemana: number): Observable<any> {
    const apiurl = `${this.url}/getAllByUserAndDiaSemana?diaSemana=${diaSemana}`;
    return this.http.get<any>(apiurl);
  }


  getTreinoCompleto(treinoId: number) {
    return this.http.get<any>(`${this.url}/${treinoId}`);
  }

  salvarExercicios(treinoId: number, payload: any[]) {
    return this.http.post(`${this.url}/${treinoId}/exercicios`, payload);
  }

  salvarAbdominais(treinoId: number, payload: any[]) {
    return this.http.post(`${this.url}/${treinoId}/abdominais`, payload);
  }

  salvarCardios(treinoId: number, payload: any[]) {
    return this.http.post(`${this.url}/${treinoId}/cardios`, payload);
  }

  getConfig(treinoId: number) {
    return this.http.get<any>(`${this.url}/${treinoId}/config`);
  }

  saveConfig(treinoId: number, data: any) {
    return this.http.put(`${this.url}/${treinoId}/config`, data);
  }

  getFullConfig(treinoId: number) {
    return this.http.get<any>(`${this.url}/${treinoId}/full`);
  }

  salvarExecucao(payload: any) {
    return this.http.post(`${this.url}/execucao`, payload);
  }

}
